import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from "react-redux";
import Select from "react-select";
import {accountInformationStart, accountSelected, setVoluumId, logOut} from "../../redux/dataUploader/dataSlice";
import {useLocation} from "react-router-dom";
import Loader from "../../components/loaders/Loader";
import OffersCheckerForm from "../../components/forms/OffersCheckerForm";
import {closeVoluumOffers} from "../../services/voluum";
import {UPLOADER_TYPE_OFFERS} from "../../constants";
import {USER_PROJECT, USER_ROLE} from "../../constants/Auth";
// import CustomSelect from "../../components/CustomSelect";
import {AUTH_TOKEN} from "../../constants/Auth";
import '../YieldkitStatusChecker/yieldkit-status-checker.scss';
import './CloseVoluumOffer.scss';
import { use } from 'react';

const ChangeVoluumByOffer = () => {
    const dispatch = useDispatch();

    const token = localStorage.getItem("auth_token");

    const checkSession = (status) => {
        if(status === 401) {
            dispatch(logOut());
        }
    }

    const currentDate = () => {
        const now = new Date();
        const day = String(now.getDate()).padStart(2, '0');
        const month = String(now.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        const year = now.getFullYear();
        return `${day}/${month}/${year}`;
    }
    
    const {pathname} = useLocation();
    const [initialValues, setInitialValues] = useState({ // eslint-disable-line no-unused-vars
        linksList: ''
    });
    const [currentValues, setCurrentValues] = useState({
        linksList: ''
    });

    const role = localStorage.getItem(USER_ROLE);
    const projectName = localStorage.getItem(USER_PROJECT);
    // const userID = localStorage.getItem('id');
    const userID = '12';
    const menuStatus = useSelector(state => state.dataUploader.collapseMenu);
    // const accountInformation = useSelector(state => state.dataUploader.accountInformation);
    const [accountInformation, setAccountInformation] = useState([]);
    const [selectedAccountInformation, setSelectedAccountInformation] = useState(null);
    const voluumId = useSelector(state => state.dataUploader.voluumId);
    const [isLoading, setLoading] = useState(false);
    const [formError, setFormError] = useState(false);
    const [formErrorMessage, setFormErrorMessage] = useState('The file is too large!');
    const [campaignIDErrorMessage, setCampaignIDErrorMessage] = useState('');
    const [voluumOfferNameErrorMessage, voluumOfferNamerrorMessage] = useState('');

    const [usersList, setUsersList] = useState([]);
    const [selectedUser, setSelectedUser] = useState({
        id: localStorage.getItem("id"),
        name: localStorage.getItem("name"),
    });
    const [anTypes, setAnTypes] = useState([]);
    const [anAccounts, setAnAccounts] = useState([]);
    const [restData, setRestData] = useState(null);
    const [selectedANType, setSelectedANType] = useState({value: 'voluum', label: 'voluum'});
    const [selectedANAccount, setSelectedANAccount] = useState(null);
    const [accError, setAccError] = useState(false);
    const [fileLinksList, setFileLinksList] = useState([]);
    const [requestSuccess, setRequestSuccess] = useState({
        status: false,
        message: ''
    });
    const [requestError, setRequestError] = useState({
        status: false,
        message: ''
    });
    const [campaignIDInput, setCampaignIDInput] = useState('');
    const [campaignID, setCampaignID] = useState([]);
    const [voluumOfferName, setVoluumOfferName] = useState(`manually deactivated - ${currentDate()}`);
    
    const [voluumOfferNameEmtry, setVoluumOfferNameEmtry] = useState(false);
    const [checkCampaignIdError, setCheckCampaignIdError] = useState(false);


    const selectStyles = {
        container: (baseStyles) => ({
            ...baseStyles,
            maxWidth: "250px",
            width: "100%",
            margin: "0 20px 20px 0",
        }),
        control: (baseStyles, state) => ({
            ...baseStyles,
            fontSize: "14px",
            lineHeight: "1.2",
            minHeight: "26px",
            border: "none",
            borderRadius: "8px",
            "&:hover": {
                cursor: "pointer",
            },
        }),
        placeholder: (baseStyles) => ({
            ...baseStyles,
            fontWeight: 500,
            color: "#1A3353",
        }),
        menu: (baseStyles, state) => ({
            ...baseStyles,
            zIndex: "6",
            "&:hover": {
                cursor: "pointer",
            },
        }),
        option: (baseStyles, state) => ({
            ...baseStyles,
            fontSize: "14px",
            lineHeight: "1.2",
            "&:hover": {
                cursor: "pointer",
            },
        }),
    }

    
      useEffect(() => {
          setLoading(true);
    
          // initial fetch
          fetch(`${localStorage.getItem("apiUrl")}api/user/${selectedUser.id}/services?status=true&is_archived=false`, {
              headers: {
                  "Accept": "application/json",
                  "Content-Type": "application/json",
                  "Authorization": `Bearer ${token}`
              },
          })
              .then(res => {
                  checkSession(res.status);
                  if (res.ok) {
                      return res.json()
                  }
                  return Promise.reject(res)
              })
              .then(res => {
    
                  setSelectedUser({id: res.id, name: res.name})
    
                  setUsersList([...res["user_managers_accounts"]])
                  setAnTypes([])
                  setAnAccounts([])
                  if (res["user_services"] && res["user_services"].length > 0) {
                      let temp = []
                      let types = [] // for unique types
                      res["user_services"].forEach(item => {
                          if (item?.types?.name && !types.includes(item?.types?.name) && item?.types?.name === "voluum" && item?.status === true) {
                              types.push(item?.types?.name)
                              temp.push({value: item?.types?.name, label: item?.types?.name})
                          }
                      })
                      setAnTypes(temp)
                  }
                  
                  if(usersList.length === 0) {
                    let tempB = [];
                    
                    tempB = res["user_services"].filter(item => item?.types?.name === 'voluum' && item?.status === true)
                    tempB = tempB.reduce((acc, item) => {
                        acc.push({value: item.id, label: item.name})
                        return acc
                    }, [])
    
                    setAnAccounts(tempB)
                    setSelectedAccountInformation(tempB[0].value || null);
                  }
    
                  setRestData(res)
                  setLoading(false)
              })
              .catch(res => {
                setLoading(false)
              })
      }, []);
    
    const sendData = async (value, { resetForm }) => {
        if(!selectedAccountInformation && role === 'admin') {
            setAccError(true);
            return;
        } else {
            setAccError(false);
            setLoading(true);
            let linksObj = [];
            const {linksList} = value;
            const linksArr = linksList
                .split(/[,\n\s]+/)
                .filter(link => link !== '' && /^[a-zA-Z0-9-]+$/.test(link))
                .filter((value, index, self) => self.indexOf(value) === index);

            const uniqueFileLinksList = fileLinksList.filter((value, index, self) => self.indexOf(value) === index);
            if(formError || linksList === '') {
                uniqueFileLinksList.forEach((el, i) => {
                    // linksObj[i] = el;
                    linksObj.push(el);
                })
            } else {
                linksArr.forEach((el, i) => {
                    // linksObj[i] = el;
                    linksObj.push(el);
                })
            }

            const data = {
                voluumAccountId: selectedAccountInformation || '',
                offers: JSON.stringify(linksObj),
                voluumOfferName: `${voluumOfferName}`,
                campaignIds: JSON.stringify(campaignID)
            }

            try {
                const response = await fetch(
                    `${localStorage.getItem("apiUrl")}api/voluum/deactivate-offers`,
                    {
                        method: "POST",
                        headers: {
                            "Accept": "application/json",
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${token}`
                        },
                        body: JSON.stringify(data)
                    }
                );
                const results = await response.json();
                
                if (results.error) {
                    setRequestSuccess({ status: false });
                    setRequestError({
                        status: true,
                        message: results.error
                    });
                } else if (results.processId) {
                    setFileLinksList([]);
                    resetForm();
                    setRequestError({ status: false });
                    setRequestSuccess({
                        status: true,
                        message: `Voluum offer ids successfully sent. Results will appear in Changed campaigns section when it's done.`
                    });
                    setCurrentValues({
                        linksList: ''
                    });
                    setTimeout(() => {
                        setRequestSuccess({ status: false, message: '' });
                    }, 5000);
                }
                setCampaignID([]);
                setCampaignIDInput('');
                setVoluumOfferName(`manually deactivated - ${currentDate()}`);
                setLoading(false);
            } catch (err) {
                console.error(err);
                setRequestSuccess({
                    status: false,
                    message: ''
                })
                setRequestError({
                    status: true,
                    message: 'Oops.. Something went wrong!'
                })
                setLoading(false);
            }
        }
    }

    const checkCampaignId = (e) => {
        const inputValue = e.target.value;
        setCampaignIDInput(inputValue);

        const ids = inputValue
            .split(/[,\s]+/)
            .map(id => id.trim())
            .filter(id => id !== '');
        setCampaignID(ids);

        if (ids.length !== 0) {
            setCheckCampaignIdError(false);
        } else {
            setCheckCampaignIdError(true);
        }
    }

    const checkVoluumOfferName = (e) => {
        setVoluumOfferName(e.target.value);
        if(e.target.value.length !== 0) {
            setVoluumOfferNameEmtry(false);
        } else {
            setVoluumOfferNameEmtry(true);
        }
    }
 
    const validatecampaignID = () => {

        let error;
        const uniqueIds = [...new Set(campaignID)];
        
        if (campaignID.length !== uniqueIds.length) {
            setCheckCampaignIdError(true);
            setFormErrorMessage('Duplicate Campaign IDs are not allowed');
            setFormError(true);
        } else {
            setCheckCampaignIdError(false);
            setFormErrorMessage('');
            setFormError(false);
            return;
        }

        return error;
    }
 
    const validateVoluumOfferName = () => {

        let error;

        if(voluumOfferName.trim().length === 0) {
            error = 'Fill in all required fields';
            setVoluumOfferNameEmtry(true);
        } 
        else {
            setVoluumOfferNameEmtry(false);
            setFormErrorMessage('');
            setFormError(false);
            return;
        }

        return error;
    }

    const validateOfferIds = value => {

        let error, valueArr, newArr;
        valueArr = value.split(/[,\n\s]+/);
        newArr = valueArr.filter(el => el && el !== '');

        if(!selectedAccountInformation && role === 'admin') setAccError(true);

        if(fileLinksList.length > 30) {
            error = 'Maximum 30 offers per one request';
            setFormErrorMessage(error);
            setFormError(true);
        } else if(newArr.length > 30) {
            error = 'Maximum 30 offers per one request';
        } else if (!value && value === '' && fileLinksList.length === 0) {
            error = 'Required';
        } else if (value !== '' && fileLinksList.length !== 0) {
            setFormError(true);
        } else if (newArr.some(el => !/^[a-zA-Z0-9-]+$/.test(el))) {
            error = 'Please provide only valid offer ids';
        } else {
            setCurrentValues(previousState => {
                return {...previousState, linksList: value}
            });
        }

        return error;
    }

    const handleChangeVoluumAccount = (account) => {
        setSelectedAccountInformation(account);
        if(account) setAccError(false);
    }

    const handleChangeSelectedUser = (user) => {
        setLoading(true);
        setSelectedAccountInformation(null);
        setCampaignID([]);
        setCampaignIDInput('');

        // fetch user services
        fetch(`${localStorage.getItem("apiUrl")}api/user/${user.value}/services?status=true&is_archived=false`, {
            headers: {
                "Accept": "application/json",
                "Content-Type": "application/json",
                "Authorization": `Bearer ${token}`

            },
        })
        .then(res => {
            checkSession(res.status);
            if (res.ok) {
                return res.json()
            }
            return Promise.reject(res)
        })
        .then(res => {
            setSelectedUser({
                id: res.id,
                name: res.name
            })
            
            setAnTypes([])
            setAnAccounts([])
            if (res["user_services"] && res["user_services"].length > 0) {
                let temp = []
                let types = [] // for unique types
                res["user_services"].forEach(item => {
                    if (item?.types?.name && !types.includes(item?.types?.name) && item?.types?.name === "voluum" && item?.status === true) {
                      types.push(item?.types?.name);
                      temp.push({value: item?.types?.name, label: item?.types?.name});
                    }
                })
                setAnTypes(temp);

                let tempB = []
                tempB = res["user_services"].filter(item => item?.types?.name === 'voluum' && item?.status === true)
                tempB = tempB.reduce((acc, item) => {
                    acc.push({value: item.id, label: item.name})
                    return acc
                }, [])
                if (tempB.length === 1) {
                  setSelectedAccountInformation(tempB[0].value);
                } else {
                  setSelectedAccountInformation(null);
                }

                setAnAccounts(tempB)
            }

            setRestData(res)
            setLoading(false);
        })
        .catch(res => {
            setLoading(false)
        })
    }

    const handleChangeANAccount = async (option) => {
        setSelectedAccountInformation(option.value);
    };


    if (isLoading) {
        return (
            <div className="loading-wrap">
                <Loader/>
            </div>
        )
    }

    return (
        <div className='yk-checker-page'>
            <div className={`changed-campaigns-container`}>
                <div style={{
                    display: "flex",
                    alignItems: "center",
                    margin: "0 0 10px",
                }}>

                    <Select
                        className={""}
                        styles={selectStyles}
                        options={usersList.length !== 0 ? usersList
                            .slice()
                            .sort((a, b) => a.name.localeCompare(b.name))
                            .reduce((acc, item) => {
                            acc.push({value: item.id, label: item.name})
                            return acc
                        }, []) : [{value: selectedUser.id, label: selectedUser.name}]}
                        isSearchable={true}
                        defaultValue={{value: selectedUser.id, label: selectedUser.name}}
                        name={"user"}
                        placeholder={"User"}
                        components={{
                            IndicatorSeparator: () => null
                        }}
                        onChange={(option) => handleChangeSelectedUser(option)}
                    />

                    <Select
                        className={""}
                        styles={selectStyles}
                        options={anAccounts
                            .slice()
                            .sort((a, b) => a.label.localeCompare(b.label))
                        }
                        isSearchable={true}
                        defaultValue={selectedANAccount}
                        name={"affiliate_network_account"}
                        placeholder={anAccounts.length === 1 ? anAccounts[0].label : "Voluum account"}
                        components={{
                            IndicatorSeparator: () => null
                        }}
                        onChange={(option) => handleChangeANAccount(option)}
                    />

                </div>
            </div>
            {selectedAccountInformation && (
                <>
                    <div className={`form-wrap textarea-checker-form-wrap${!menuStatus ? ' collapsed-menu' : ''}`}>
                        <OffersCheckerForm
                            type={UPLOADER_TYPE_OFFERS}
                            initialValues={initialValues}
                            currentValues={currentValues}
                            validate={validateOfferIds}
                            validateVoluumOfferName={validateVoluumOfferName}
                            onSubmit={sendData}
                            campaignID={campaignID}
                            campaignIDInput={campaignIDInput}
                            checkCampaignId={checkCampaignId}
                            validatecampaignID={validatecampaignID}
                            voluumOfferName={voluumOfferName}
                            voluumOfferNameEmtry={voluumOfferNameEmtry}
                            checkCampaignIdError={checkCampaignIdError}
                            checkVoluumOfferName={checkVoluumOfferName}
                            isLoading={isLoading}
                            fileLinksList={fileLinksList}
                            setFileLinksList={setFileLinksList}
                            formError={formError}
                            setFormError={setFormError}
                            fileText={'Or upload a tab file with Voluum offer ids in one column'}
                        />
                        {formError ? <span className='yk-checker-form-error'>{formErrorMessage}</span> : null}
                    </div>
                    {requestSuccess.status ? <span className='new-user-success'>{requestSuccess.message}</span> : null}
                    {requestError.status ? <span className='new-user-error'>{requestError.message}</span> : null}
                </>
            )}
            
        </div>
    )
}

export default ChangeVoluumByOffer;